import React from 'react';

// Usa os tokens do Jusfy DS: precisa estar dentro de .jds-scope.
export const DetailRow = ({ label, boldRow, boldValue, children }) => (
  <div className="d-flex justify-content-between align-items-center">
    <span
      className="text-dark"
      style={{ fontWeight: boldRow ? 'var(--fw-bold)' : 'var(--fw-regular)' }}
    >
      {label}
    </span>
    <span
      className={boldRow || boldValue ? 'text-dark' : 'text-dark-50'}
      style={{
        textAlign: 'right',
        fontWeight: boldRow
          ? 'var(--fw-bold)'
          : boldValue
          ? 'var(--fw-medium)'
          : 'var(--fw-regular)',
      }}
    >
      {children}
    </span>
  </div>
);
